<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <CWrapper>
      <TheSuppliersHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
    <loading :active="visible" :can-cancel="true"></loading>
    <CToaster placement="top-end">
      <div v-for="(toast, key) in toasts" :key="'toast' + key">
        <CToast :color="toast.color" v-bind="toast" :show="true">
          {{toast.content}}
        </CToast>
      </div>
    </CToaster>
  </div>
</template>
<script>
import TheSidebar from './TheSidebar'
import TheSuppliersHeader from './TheSuppliersHeader'
import TheFooter from './TheFooter'
import store from '../store'
import Vue from 'vue';
import Loading from 'vue-loading-overlay/dist/vue-loading.js';
import 'vue-loading-overlay/dist/vue-loading.css';
import ws from '../services/general';

export default {
  name: 'TheSupplierContainer',
  components: {
    TheSidebar,
    TheSuppliersHeader,
    TheFooter,
    Loading
  },
  data() {
      return {
        
      }
  },
  mounted: async function() {
    let response = await ws.getParameters(); 

    if(response.type == "success"){
      store.commit('parameters', response.data);
    }
  }, 
  computed: {
    toasts () {
      return store.state.toasts;
    },
    visible() {
      return store.state.isLoading;
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
